import { render } from "./add-admin.vue?vue&type=template&id=6e70ba4c&scoped=true"
import script from "./add-admin.vue?vue&type=script&lang=js"
export * from "./add-admin.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./add-admin.vue?vue&type=style&index=1&id=6e70ba4c&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e70ba4c"]])

export default __exports__